import React from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { sxStyles } from "../sharedStyles";
import { IPriceItinerary } from "../interfaces.lowPrice";
import { SxProps } from "@mui/material";

interface IProps {
  selectedItineraryId: string | null;
  priceItinerary: IPriceItinerary;
}

export const InfoIcon = (props: IProps) => {
  const { selectedItineraryId, priceItinerary } = props;
  const { infoIcon } = sxStyles;

  const sx: SxProps = {
    ...infoIcon,
    color:
      selectedItineraryId === priceItinerary.studentOrYouthData.id
        ? "white.main"
        : "info.main",
  };
  return priceItinerary.studentOrYouthData.travelerType === "YTH" ? (
    <InfoOutlined sx={sx} />
  ) : (
    <InfoRoundedIcon sx={sx} />
  );
};
